module.exports = __webpack_public_path__ + "images/menos-sacolas.jpg?aab482f8926d3933eb93b85355073e76";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/menos-sacolas.jpg
// module id = 987
// module chunks = 0